import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Map } from "immutable";
import { shortDate } from "LIB/formatters/date";
import { dollars } from "LIB/formatters/currency";
import {
  Authorized,
  ClipboardCopy,
  ExternalLink,
  Forbidden,
  Icon,
  StatusTag
} from "MODULES/shared/components";
import {
  ACCOUNTING,
  ADMIN,
  QUALITY_CONTROL,
  WAREHOUSE,
  WAREHOUSE_LOGISTICS_DIRECTOR
} from "MODULES/users/constants";
import {
  ALLOW_SENDING,
  CANCELLATION_REASONS,
  DO_NOT_SHIP,
  REJECTED,
  REQUIRES_APPROVAL,
  TRACE_HOLD,
  TRACE_HOLD_APPROVED
} from "MODULES/PurchaseOrders/constants";
import {
  API_BASE,
  CANCELLED,
  CODE,
  CREATED_AT,
  LINE_ITEMS,
  RECEIVED,
  SHIPPING_TYPE,
  TOTAL
} from "APP_ROOT/constants";
import { QC_HOLD } from "MODULES/inventories/constants";
import RecordPager from "MODULES/shared/components/RecordPager/RecordPager";
import DropDownItem from "MODULES/shared/components/DropDown/DropDownItem";
import ConfirmAction from "MODULES/shared/components/ConfirmAction/ConfirmAction";
import {
  approve,
  cancel,
  setTraceHold,
  update
} from "MODULES/PurchaseOrders/actions";
import ActionDropDown from "MODULES/shared/components/ActionDropDown/ActionDropDown";
import SetTraceHold from "MODULES/PurchaseOrders/components/Detail/SetTraceHold";
import RemoveFromQCHold from "MODULES/shared/components/RemoveFromQCHold";
import api from "APP_ROOT/api";
import SendEmail from "MODULES/shared/components/SendEmail/SendEmail";
import withCurrentUser from "MODULES/session/decorators/withCurrentUser";
import UpdateQcStatus from "MODULES/PurchaseOrders/components/Detail/UpdateQcStatus/UpdateQcStatus";
import Sync from "MODULES/PurchaseOrders/components/Detail/Sync/Sync";
import ToggleQuickbooksSync from "MODULES/PurchaseOrders/components/Detail/ToggleQuickbooksSync/ToggleQuickbooksSync";
import StatusTags from "./StatusTags";
import Warnings from "./Warnings";
import Send from "./Send";
import EditInvoiceDetails from "./EditInvoiceDetails";
import { SendModal } from "./Send/SendModal";
import SendCancelledPo from "./SendCancelledPo";
import CancelSendPo from "./CancelSendPo/CancelSendPo";

export class Header extends React.Component {
  state = {
    approvePOModalOpen: false,
    cancelPOModalOpen: false,
    releaseExportHoldModalOpen: false,
    cancellationReason: CANCELLATION_REASONS[0].value,
    sendToModalOpen: false,
    showSendCancelledPoModal: false
  };

  onConfirmToRemoveFormQCHoldClick = () => {
    const { updatePurchaseOrder } = this.props;
    updatePurchaseOrder({ qc_hold: false });
  };

  setTraceHold = approveTraceHold => {
    const { setTraceHold: traceHoldSet } = this.props;
    traceHoldSet(approveTraceHold);
  };

  openApprovePOModalOpen = () => {
    this.setState({ approvePOModalOpen: true });
  };

  closeApprovePOModalOpen = () => {
    this.setState({ approvePOModalOpen: false });
  };

  openSendToModal = () => {
    this.setState({ sendToModalOpen: true });
  };

  closeSendToModal = () => {
    this.setState({ sendToModalOpen: false });
  };

  handleSelectChange = e => {
    this.setState({ cancellationReason: e.target.value });
  };

  openReleaseExportHoldModal = () =>
    this.setState({ releaseExportHoldModalOpen: true });
  closeReleaseExportHoldModal = () =>
    this.setState({ releaseExportHoldModalOpen: false });

  render() {
    const {
      currentUser,
      purchaseOrder,
      approvePurchaseOrder,
      received = false,
      releaseExportHold,
      id
    } = this.props;
    const {
      approvePOModalOpen,
      cancelPOModalOpen,
      releaseExportHoldModalOpen,
      sendToModalOpen,
      showSendCancelledPoModal
    } = this.state;
    const url = `${API_BASE}/purchase_orders/${id}/download`;
    const cancelled = purchaseOrder.get(CANCELLED);
    const lineItems = purchaseOrder.get(LINE_ITEMS);
    const fullyReceived =
      lineItems.size > 0 && lineItems.every(item => item.get(RECEIVED));
    const isInHold = purchaseOrder.get(QC_HOLD);
    const buyerId = purchaseOrder.get("buyer_id");
    const coBuyerId = purchaseOrder.get("co_buyer_id");

    return (
      <div className="page-header page-header-bar">
        <SendModal
          purchaseOrder={purchaseOrder}
          visible={sendToModalOpen}
          close={this.closeSendToModal}
        />
        <h1>
          <div className="btn-group pull-right" style={{ marginLeft: 20 }}>
            <ActionDropDown
              menuClass="dropdown-menu-right"
              style={{ cursor: "pointer" }}
            >
              {!cancelled && (
                <DropDownItem
                  onClick={this.openApprovePOModalOpen}
                  disabled={!purchaseOrder.get("can_approve")}
                >
                  <i className="fa fa-fw fa-check" />
                  &nbsp;Approve PO
                </DropDownItem>
              )}
              <Authorized roles={[ACCOUNTING, QUALITY_CONTROL]}>
                <EditInvoiceDetails purchaseOrder={purchaseOrder} />
              </Authorized>
              <React.Fragment>
                {!isInHold &&
                  (!purchaseOrder.get(TRACE_HOLD) ||
                    purchaseOrder.get(TRACE_HOLD_APPROVED)) &&
                  (purchaseOrder.get(ALLOW_SENDING) ||
                    currentUser.role === ADMIN) && (
                    <React.Fragment>
                      {!cancelled && [
                        <Send purchaseOrder={purchaseOrder} />,
                        <UpdateQcStatus purchaseOrder={purchaseOrder} />,
                        <li>
                          <ExternalLink url={url}>
                            <Icon name="file-text-o" fixed />
                            &nbsp;Download PO
                          </ExternalLink>
                        </li>
                      ]}
                    </React.Fragment>
                  )}
                <Authorized
                  roles={[QUALITY_CONTROL]}
                  subroles={[WAREHOUSE_LOGISTICS_DIRECTOR]}
                >
                  <DropDownItem onClick={this.openReleaseExportHoldModal}>
                    <i className="fa fa-fw fa-check" />
                    &nbsp;Release Export Hold
                  </DropDownItem>
                </Authorized>
                {!isInHold &&
                  (!purchaseOrder.get(TRACE_HOLD) ||
                    purchaseOrder.get(TRACE_HOLD_APPROVED)) &&
                  (purchaseOrder.get(ALLOW_SENDING) ||
                    currentUser.role === ADMIN) && (
                    <React.Fragment>
                      {!cancelled && [
                        <SendEmail
                          record={purchaseOrder}
                          label={"request for shipping status"}
                          url={api.purchaseOrders}
                          type="status"
                          warning={
                            purchaseOrder.get(SHIPPING_TYPE) === DO_NOT_SHIP &&
                            "'Do not ship' selected."
                          }
                        />
                      ]}
                    </React.Fragment>
                  )}
              </React.Fragment>
              <Authorized roles={[QUALITY_CONTROL]}>
                <RemoveFromQCHold
                  order={purchaseOrder}
                  onConfirm={this.onConfirmToRemoveFormQCHoldClick}
                />
                <SetTraceHold
                  onConfirm={() => this.setTraceHold(true)}
                  purchaseOrder={purchaseOrder}
                  traceApproved
                />
                <SetTraceHold
                  onConfirm={() => this.setTraceHold(false)}
                  purchaseOrder={purchaseOrder}
                  traceApproved={false}
                />
              </Authorized>
              <Authorized roles={[ACCOUNTING]}>
                <ToggleQuickbooksSync purchaseOrder={purchaseOrder} />
                <Sync purchaseOrder={purchaseOrder} />
              </Authorized>
              {!cancelled && !received && <li className="divider" />}
              <Forbidden
                roles={[WAREHOUSE]}
                buyerId={buyerId}
                coBuyerId={coBuyerId}
              >
                {!received && (
                  <React.Fragment>
                    {cancelled && (
                      <SendCancelledPo
                        purchaseOrder={purchaseOrder}
                        showModal={showSendCancelledPoModal}
                        onClose={() =>
                          this.setState({ showSendCancelledPoModal: false })}
                      />
                    )}
                    <CancelSendPo
                      cancelled={cancelled}
                      cancelPurchaseOrder={this.props.cancelPurchaseOrder}
                      purchaseOrder={purchaseOrder}
                    />
                  </React.Fragment>
                )}
              </Forbidden>
            </ActionDropDown>
          </div>
          <div className="with-padding">
            <RecordPager baseUrl="/purchase-orders" record={purchaseOrder} />
            <span className="header-content">{purchaseOrder.get(CODE)}</span>
            <ClipboardCopy name={purchaseOrder.get(CODE)} type="PO" />
            <span className="small text-muted">
              Created {shortDate(purchaseOrder.get(CREATED_AT))}
            </span>
            <span className="pull-right">
              {purchaseOrder.get(QC_HOLD) && (
                <StatusTag title="QC Hold" icon="pause" display="danger" />
              )}
              <span className="small text-muted">
                {purchaseOrder.get(LINE_ITEMS, []).size} Item(s)
              </span>
              <span>Total: {dollars(purchaseOrder.get(TOTAL))}</span>
            </span>
            <StatusTags
              purchaseOrder={purchaseOrder}
              rejected={purchaseOrder.get(REJECTED)}
              traceHold={purchaseOrder.get(TRACE_HOLD)}
              traceHoldApproved={purchaseOrder.get(TRACE_HOLD_APPROVED)}
              received={fullyReceived}
              requiresApproval={purchaseOrder.get(REQUIRES_APPROVAL)}
            />
            <div className="alert-group pull-right">
              <Warnings purchaseOrder={purchaseOrder} />
            </div>
          </div>
        </h1>

        <ConfirmAction
          onConfirm={approvePurchaseOrder}
          open={approvePOModalOpen}
          close={this.closeApprovePOModalOpen}
          icon={<i className="fa fa-fw fa-check" />}
          btnText="Yes, Approve PO"
        >
          <strong>Heads up!</strong>
          <p>Are you sure you want to approve this PO?</p>
        </ConfirmAction>
        <ConfirmAction
          onConfirm={releaseExportHold}
          open={releaseExportHoldModalOpen}
          close={this.closeReleaseExportHoldModal}
          icon={<i className="fa fa-fw fa-check" />}
          btnText="Yes, Release Export Hold"
        >
          <strong>Heads up!</strong>
          <p>Are you sure you want to release this Export Hold?</p>
        </ConfirmAction>
        <Forbidden roles={[WAREHOUSE]} buyerId={buyerId} coBuyerId={coBuyerId}>
          <ConfirmAction
            onConfirm={this.handleCancelPurchaseOrder}
            close={this.closeCancelPOModal}
            open={cancelPOModalOpen}
            btnClass={cancelled ? "btn-primary" : "btn-danger"}
            btnText={cancelled ? "Reverse Cancellation" : "Yes, Cancel PO"}
            cancelText={cancelled ? "Cancel" : "Do Not Cancel PO"}
            icon={
              cancelled ? (
                <i className="fa fa-fw fa-refresh" />
              ) : (
                <i className="fa fa-fw fa-ban" />
              )
            }
          >
            <strong>Heads up!</strong>
            &nbsp;
            {cancelled
              ? "Are you sure you want to reverse this cancelled order?"
              : "Cancelling a PO will cancel all line items associated with it."}
            {!cancelled && (
              <div>
                <label className="control-label" htmlFor="cancellation_reason">
                  Cancellation Reason
                </label>
                <select
                  className="form-control"
                  name="cancellation_reason"
                  onChange={this.handleSelectChange}
                >
                  {CANCELLATION_REASONS.map(reason => (
                    <option key={reason.value} value={reason.value}>
                      {reason.text}
                    </option>
                  ))}
                </select>
              </div>
            )}
          </ConfirmAction>
        </Forbidden>
      </div>
    );
  }
}

export default connect(
  state => ({
    id: state.purchaseOrderDetail.getIn(["purchaseOrder", "id"])
  }),
  dispatch => ({
    cancelPurchaseOrder: data => dispatch(cancel(data)),
    approvePurchaseOrder: () => dispatch(approve()),
    releaseExportHold: () => dispatch(update({ export_hold: false })),
    setTraceHold: val => dispatch(setTraceHold(val)),
    updatePurchaseOrder: data => dispatch(update(data))
  })
)(withCurrentUser(Header));

Header.propTypes = {
  currentUser: PropTypes.shape({}),
  purchaseOrder: PropTypes.instanceOf(Map),
  id: PropTypes.number.isRequired,
  received: PropTypes.bool.isRequired,
  approvePurchaseOrder: PropTypes.func.isRequired,
  cancelPurchaseOrder: PropTypes.func.isRequired,
  setTraceHold: PropTypes.func.isRequired,
  updatePurchaseOrder: PropTypes.func.isRequired
};



// WEBPACK FOOTER //
// ./app/modules/PurchaseOrders/components/Detail/Header.jsx